import { AsyncThunkActionVoid } from 'actions/actions.types'
import { fetchOutsideContactsApi } from 'api/messenger/fetchOutsideContactsApi'
import { hasUserRestrictions } from 'functions/hasUserRestrictions'

export const FETCH_OUTSIDE_CONTACTS = 'FETCH_OUTSIDE_CONTACTS' as const

export const fetchOutsideContactsAction =
  (): AsyncThunkActionVoid => (dispatch, getState) => {
    const state = getState()

    if (!hasUserRestrictions(state)) {
      dispatch(fetchOutsideContactsPlainAction())
    }
  }

export const fetchOutsideContactsPlainAction = () => ({
  type: FETCH_OUTSIDE_CONTACTS,
  promise: () => fetchOutsideContactsApi(),
})
